import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAvailableProductBanners,
  getProductBanners,
} from '../redux/pos/posSlice';
import { getImagePath } from '../constants/defaultValues';

const Banner = () => {
  const dispatch = useDispatch();
  const rawBanners = useSelector(getAvailableProductBanners);

  useEffect(() => {
    dispatch(getProductBanners({ forMobile: false }));
  }, [dispatch]);

  const productBanners = useMemo(() => {
    return (rawBanners || []).filter((p) => {
      return p.productBanner?.image?.fileToken || p.image?.fileToken;
    });
  }, [rawBanners]);

  if (productBanners.length === 0) return null;

  return (
    <section className="banner-container container-fluid position-relative top-0 p-0 mb-5 mt-0">
      <div
        id="bannerSlider"
        className="carousel slide carousel-fade"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          {productBanners.map((_, idx) => (
            <button
              key={idx}
              type="button"
              data-bs-target="#bannerSlider"
              data-bs-slide-to={idx}
              className={idx === 0 ? 'active' : ''}
              aria-current={idx === 0 ? 'true' : undefined}
              aria-label={`Slide ${idx + 1}`}
            ></button>
          ))}
        </div>

        {/* Carousel Items */}
        <div className="carousel-inner">
          {productBanners.map((p, idx) => (
            <div
              key={idx}
              className={`carousel-item ${idx === 0 ? 'active' : ''}`}
              data-bs-interval="5000" // Har slide 5 seconds tak rukegi
            >
              <img
                src={`${getImagePath}${p.productBanner.image.fileToken}`}
                className="d-block w-100 banner-img"
                alt={`Banner ${idx + 1}`}
                style={{
                  objectFit: 'cover',
                  height: '500px', // Responsive banane ke liye isse media queries mein adjust karein
                  width: '100%',
                }}
              />
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#bannerSlider"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>

        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#bannerSlider"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </section>
  );
};

export default Banner;
